import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle, faStopCircle } from '@fortawesome/free-solid-svg-icons';

const ChatMessage = ({
	message,
	currentUsername,
	onPlayAudio,
	onPauseAudio,
	audioEnabled,
	isCurrentlyPlaying,
}) => {
	// For system messages like "User has joined"
	if (message.type === 'system') {
		return (
			<div>
				<b>{message.message}</b>
			</div>
		);
	}

	const isCurrentUser = message.username === currentUsername;
	const isModerator = message.username === 'MODERATOR';
	const messageType = isModerator ? 'moderator' : 'user';

	const formatTimestamp = (timestamp) => {
		const date = new Date(timestamp);

		const day = date.getDate().toString().padStart(2, '0');
		const month = (date.getMonth() + 1).toString().padStart(2, '0');
		const year = date.getFullYear();

		const hours = date.getHours().toString().padStart(2, '0');
		const minutes = date.getMinutes().toString().padStart(2, '0');

		return `${day}/${month}/${year}, ${hours}:${minutes}`;
	};

	const handlePlayClick = () => {
		if (onPlayAudio) {
			const audioUrl = `${
				process.env.REACT_APP_BASE_URL || '/'
			}api/messages/audio?group_id=${message.group_id}&message_id=${
				message.message_id
			}`;
			onPlayAudio(audioUrl, message.message_id);
		}
	};

	const handlePauseClick = () => {
		if (onPauseAudio) {
			onPauseAudio();
		}
	};

	return (
		<div>
			<div className={`chat-container-${isCurrentUser ? 'self' : 'other'}`}>
				<div className={`chat-message chat-message-${messageType} text-break`}>
					<div className="chat-username">
						{message.username}

						{audioEnabled && (
							<>
								{/* Show play button when not currently playing this message */}
								{!isCurrentlyPlaying && (
									<span
										className="chat-play-button-container"
										style={{ display: 'inline' }}
									>
										<button
											className={`chat-play-button chat-play-button-${messageType}`}
											onClick={handlePlayClick}
										>
											<FontAwesomeIcon icon={faPlayCircle} />
										</button>
									</span>
								)}

								{/* Show pause button when currently playing this message */}
								{isCurrentlyPlaying && (
									<span
										className="chat-pause-button-container"
										style={{ display: 'inline' }}
									>
										<button
											className={`chat-pause-button chat-pause-button-${messageType}`}
											onClick={handlePauseClick}
										>
											<FontAwesomeIcon icon={faStopCircle} />
										</button>
									</span>
								)}
							</>
						)}
					</div>

					<div className="chat-text" data-message-id={message.message_id}>
						{message.message}
					</div>

					<div className="chat-time">
						{message.timestamp ? formatTimestamp(message.timestamp) : ''}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ChatMessage;
